import { render, staticRenderFns } from "./_spribe.vue?vue&type=template&id=c95e1f6c&lang=pug&"
import script from "./_spribe.vue?vue&type=script&lang=js&"
export * from "./_spribe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports